import gql from "graphql-tag"
import fullDealsTag from "./fullDealsTag"

const fragment = gql`
  fragment fullDealCategory on DealCategory {
    active
    image
    name
    onMenu
    url
    uuid
    type
    isGeolocationRelated
    tags {
      ...fullDealsTag
    }
    dealCount
  }
  ${fullDealsTag}
`

export default fragment
